import { render } from "./NewOrderModal.vue?vue&type=template&id=0041544b&scoped=true"
import script from "./NewOrderModal.vue?vue&type=script&lang=js"
export * from "./NewOrderModal.vue?vue&type=script&lang=js"

import "./NewOrderModal.vue?vue&type=style&index=0&id=0041544b&lang=less&scoped=true"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0041544b"]])

export default __exports__